import { useCallback, useEffect, useRef } from 'react';

type Callback<A extends unknown[]> = (...args: A) => void;

export const useOneTimeCallback = <A extends unknown[]>(callback: Callback<A>, key: string) => {
    const callbackRef = useRef(callback);
    const callsRef = useRef<Record<string, boolean>>({});

    useEffect(() => {
        callbackRef.current = callback;
    }, [callback]);

    const wrapper: Callback<A> = useCallback(
        (...args: A) => {
            if (callsRef.current[key]) {
                return;
            }

            callsRef.current[key] = true;

            return callbackRef.current(...args);
        },
        [key],
    );

    return wrapper;
};
